import React, { useState } from 'react';
import { cn } from '../../lib/utils';
import { JOURNEY_STAGES } from '../../lib/journeyStages';
import { ZoomableTrendChart } from './ZoomableTrendChart';

/**
 * NavigationReadinessTrend — the page-level trend instrument.
 *
 * Defaults to the Navigation Readiness (PE composite) line so
 * executives see "is navigation improving?", with drill-down pills
 * for each journey stage. When a sub-stage is selected, the
 * Navigation line stays visible as a dashed reference.
 */
export function NavigationReadinessTrend({ trends }) {
  const [stageKey, setStageKey] = useState('navigation');
  const stage = JOURNEY_STAGES.find((s) => s.key === stageKey);

  const lines = stageKey === 'navigation'
    ? [{ dataKey: 'pe', name: 'Navigation Readiness', stroke: stage.color }]
    : [
        { dataKey: stage.metric, name: stage.label, stroke: stage.color },
        { dataKey: 'pe', name: 'Navigation (reference)', stroke: '#94a3b8', dashed: true, dot: false, strokeWidth: 1.5 },
      ];

  const toolbar = (
    <div className="flex flex-wrap gap-1.5" data-testid="nav-trend-stage-tabs">
      {JOURNEY_STAGES.map((s) => (
        <button
          key={s.key}
          type="button"
          onClick={() => setStageKey(s.key)}
          data-testid={`nav-trend-tab-${s.key}`}
          className={cn(
            'rounded-full border px-2.5 py-1 text-[11px] font-medium transition-colors',
            stageKey === s.key
              ? 'border-transparent text-white shadow-sm'
              : 'border-slate-200 bg-white text-slate-500 hover:text-slate-700 hover:bg-slate-50',
          )}
          style={stageKey === s.key ? { backgroundColor: s.color } : undefined}
        >
          {s.label}
        </button>
      ))}
    </div>
  );

  return (
    <ZoomableTrendChart
      data={trends}
      title={stageKey === 'navigation' ? 'Navigation Readiness Trend' : `${stage.label} Trend`}
      subtitle={
        stageKey === 'navigation'
          ? 'Is navigation improving — not just capability?'
          : `${stage.blurb} · dashed line = Navigation Readiness reference`
      }
      toolbar={toolbar}
      testIdPrefix="nav-readiness"
      height={300}
      lines={lines}
    />
  );
}
